export const TEXT = {
  headerText: {
    headline: 'Deine Reise mit Balloon und der {{companyName}}',
    subline: 'Starte jetzt deinen Präventionskurs und sichere dir zusätzlichen Zugriff auf alle Inhalte der Balloon-App.',
    button: 'Zur Kursübersicht',
    buttonStartNow: 'Jetzt starten',
    altText: '{{companyName}} Logo',
    addOnText: 'Ein Online-Coaching von Balloon'
  },
  infoSectionText: {
    headline: 'Balloon und die {{companyName}} machen dein Leben leichter.',
    text: 'Balloon sorgt für weniger Stress, mehr innere Stärke und besseren Schlaf. Versicherte der {{companyName}} erhalten in der App Zugang zu einem zertifizierten und wissenschaftlich fundierten Präventionskursangebot mit mehr als 50 Audio-Einheiten und über 600 Minuten Inhalt. Ergänzend steht eine vielfältige Meditations- und Inspirationsbibliothek rund um mentale Gesundheit und Achtsamkeit zur Verfügung. Balloon unterstützt dich im Alltag – Schritt für Schritt, in deinem Tempo.'
  },
  courseSectionText: {
    headline: 'Kurse der {{companyName}}'
  },
  trustText: { headline: 'Balloon ist bekannt aus:' },
  courseTile: {
    sda: 'Stressreduktion',
    resilienz: 'Resilienz'
  },
  formText: {
    headline: 'Registrierung für Versicherte \nder {{companyName}}',
    description:
      'Registriere dich hier mit deiner Versichertennummer und schalte deinen Präventionskurs frei. Bei Fragen wende dich gern an',
    placeholder: {
      name: 'Vor- und Nachname *',
      email: 'E-Mail-Adresse *',
      companyNameReq: 'Firma *',
      companyName: '(optional) Firma',
      postalCodeReq: 'PLZ deines Wohnsitzes *',
      postalCode: '(optional) PLZ deines Wohnsitzes',
      insuranceNumberReq: 'Versichertennummer *',
      insuranceNumber: '(optional) Versichertennummer',
      dateOfBirthReq: 'Geburtsdatum (TT.MM.JJJJ) *',
      dateOfBirth: '(optional) Geburtsdatum (TT.MM.JJJJ)',
      ageReq: 'Alter *',
      age: '(optional) Alter',
      genderReq: 'Geschlecht *',
      gender: '(optional) Geschlecht'
    },

    personalDataSync:
      'Ich bin damit einverstanden, dass meine persönlichen Daten, die ich hier im Formular angegeben habe, sowie mein Kursfortschritt an meine Krankenkasse übermittelt werden.',
    insuranceNumberInfo: 'Deine Versichertennummer findest du auf deiner Krankenkassenkarte.',
    courseParticipationLimitAccepted:
      'Hiermit bestätige ich, dass ich in diesem Kalenderjahr noch nicht an zwei Präventionskursen teilgenommen habe.',
    costCoverageConditionAccepted:
      'Mir ist bewusst, dass die Übernahme der Kosten durch meine Krankenkasse auf einem erfolgreichen Kursabschluss beruht.'
  },

  refundBox: {
    asteriskText:
      '* Freischaltung endet automatisch nach einem Jahr und wird nicht verlängert. Erfordert ein Smartphone mit Android 8.0 bzw. iOS 13.0 oder höher. Alle gesetzlichen Regelungen zum Einsatz des digitalen Präventions- bzw. Gesundheitsförderungsangebots sind berücksichtigt.',
    infoText: 'inkl. {{contentAccessDuration}} Monate Balloon'
  }
};
